import React from 'react';
import { PurchaseHistory } from 'ai-api/types/purchase';
import PurchaseHistoryItem from './PurchaseHistoryItem';
import './PurchaseHistoryList.scss';

interface PurchaseHistoryListProps {
    purchases: PurchaseHistory[];
    onViewDetails: (purchase: PurchaseHistory) => void;
    loading?: boolean;
    error?: string | null;
}

const PurchaseHistoryList: React.FC<PurchaseHistoryListProps> = ({
    purchases,
    onViewDetails,
    loading = false,
    error = null
}) => {
    if (loading) {
        return (
            <div className="purchase-history-loading">
                <div className="loading-spinner"></div>
                <p>Loading your purchase history...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="purchase-history-error">
                <p className="error-message">{error}</p>
                <button onClick={() => window.location.reload()} className="retry-button">Retry</button>
            </div>
        );
    }

    if (purchases.length === 0) {
        return (
            <div className="purchase-history-empty">
                <div className="empty-icon">📋</div>
                <h3>No Purchases Yet</h3>
                <p>You haven't made any purchases yet. Browse our products to start your Korean learning journey!</p>
                <a href="/" className="browse-button">Browse Products</a>
            </div>
        );
    }

    return (
        <div className="purchase-history-list">
            {purchases.map(purchase => (
                <PurchaseHistoryItem
                    key={purchase.orderid}
                    purchase={purchase}
                    onViewDetails={onViewDetails}
                />
            ))}
        </div>
    );
};

export default PurchaseHistoryList;